import React, {useCallback, useContext, useEffect, useState} from 'react';

import {DateInput, NumberInput, NumberInputTypes} from 'src/components/input';
import {RequiredMark} from 'src/components/required-mark/required-mark';
import {MAX_CONTRACT_FIELD_VALUE} from 'src/modules/profile/account/constants';

import {Float, Integer} from '@pb/kit-component-formatters';
import {Group, Item} from '@pb/kit-component-group';
import Label from '@pb/kit-component-label';
import {LocaleContext} from '@pb/kit-context-locale';

import {INPUT_WIDTH, NAMES} from '../constants';

import {apiV2AddContractSingleDate} from './add-contract-modal.module.styl';

import type {EditPPCContract} from '../typedef';

type Props = {
    disabled: boolean,
    onEditData: (data: EditPPCContract) => void,
};

type PayPerCallData = {
    costPerCredit?: number,
    initialPackage?: number,
    startDate: string,

};
const DEFAULT_STATE: PayPerCallData = {
    startDate: '',
};

export const PPCContractDetails = ({disabled, onEditData}: Props) => {
    const {locale} = useContext(LocaleContext);
    const [data, setData] = useState<PayPerCallData>(DEFAULT_STATE);
    const [startDate, setStartDate] = useState('');

    const {initialPackage, costPerCredit} = data;

    useEffect(() => {
        onEditData({
            startDate,
            costPerCredit: costPerCredit || 0,
            initialPackage: initialPackage || 0,
        });
    }, [startDate, initialPackage, costPerCredit]); // eslint-disable-line react-hooks/exhaustive-deps

    const onChangeNumber = useCallback((value?: number, name?: string) => {
        if (name) {
            setData(prevState => ({
                ...prevState,
                [name]: value,
            }));
        }
    }, []);

    return (
        <Group direction="v">
            <Item className={apiV2AddContractSingleDate}>
                <Label><RequiredMark label="Contract Start Date"/></Label>
                <DateInput
                    {...{
                        width: INPUT_WIDTH,
                        id: 'contract-start-date',
                        selectedDate: startDate,
                        clearable: true,
                        onChange: setStartDate,
                        isLocalDate: false,
                    }}
                />
            </Item>
            <NumberInput
                inputType={NumberInputTypes.POSITIVE_FLOAT}
                label={<RequiredMark label="Cost per Credit"/>}
                maxValue={MAX_CONTRACT_FIELD_VALUE}
                value={costPerCredit}
                width={INPUT_WIDTH}
                readOnly={disabled}
                placeholder="$, USD"
                displayedValue={costPerCredit ? Float.format(costPerCredit, locale) : ''}
                onBlur={value => onChangeNumber(value, NAMES.costPerCredit)}
            />
            <NumberInput
                label={<RequiredMark label="Initial Package"/>}
                maxValue={MAX_CONTRACT_FIELD_VALUE}
                width={INPUT_WIDTH}
                value={initialPackage}
                readOnly={disabled}
                placeholder="Number of Credits"
                displayedValue={initialPackage ? Integer.format(initialPackage, locale) : ''}
                onBlur={value => onChangeNumber(value, NAMES.initialPackage)}
            />
        </Group>
    );
};
